import AppDispatcher from '../../core/AppDispatcher'
import DailyClosingEvent from '../../event/DailyClosingEvent'

const onEditDetail = (event, index) => {
  AppDispatcher.dispatchWithType(DailyClosingEvent.onEditDetail, {
    index: index,
    name: event.target.name,
    value: event.target.value
  })

  return true
}

export default onEditDetail
